/**
 * @file The S1 queue view of a PDF intake job, derived from its `status` and
 * `route`: `verified` once approved, or `ready` with route `auto_verified` or
 * `escalated`; `needsReview` when `ready` with route `review` (or, never in
 * practice, no route yet, which a person must look at); `processing` while the
 * pipeline or an approval works, and when it `failed`, so a failed page stays
 * with the pipeline's work; `dismissed` when a person dismissed it, a view no
 * S1 tab filters on, so only All lists it. Pure and shared: `pdfIntakeJobWrite` and
 * `pdfIntakeJobOpen` write it, `pdfIntakeJobFromSnapshot` derives it for a job
 * stored without one, and the seed jobs carry it.
 */
import type { PdfIntakeJobStatus, PdfIntakeQueue } from './System.PdfIntakeJob.types';
import type { PdfIntakeRoute } from './System.Agent.PdfEvidence.types';

export function pdfIntakeJobQueue(job: { status: PdfIntakeJobStatus; route: PdfIntakeRoute | null }): PdfIntakeQueue {
    switch (job.status) {
        case 'approved':
            return 'verified';
        case 'ready':
            return job.route === 'auto_verified' || job.route === 'escalated' ? 'verified' : 'needsReview';
        case 'processing':
        case 'approving':
        case 'failed':
            return 'processing';
        case 'dismissed':
            return 'dismissed';
    }
}
